<template>
  <div>
    <div
      v-if="showLdapBindDn"
      :class="$style.item"
    >
      <i :class="['jc-ldap-circle', 'ldap-brand', $style.icon]" />
      <span :class="$style.text">LDAP Bind DN</span>
    </div>
    <div
      v-if="showSambaServiceAccount"
      :class="$style.item"
    >
      <i :class="['jc-samba-circle', 'samba-brand', $style.icon]" />
      <span :class="$style.text">Samba Service Account</span>
    </div>
  </div>
</template>
<script>
import { DirectoryTypeConsts } from 'client/util/Constants';
import { values } from 'lodash';
import AsidePanelChildComponentMethodsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentMethodsMixin';
import AsidePanelChildComponentPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelChildComponentPropsMixin';

export default {
  name: 'DirectoryAccessConfiguration',

  mixins: [
    AsidePanelChildComponentMethodsMixin,
    AsidePanelChildComponentPropsMixin,
  ],

  props: {
    item: {
      required: true,
      type: Object,
      validator: item => !!(item && values(DirectoryTypeConsts).indexOf(item.type) !== -1),
    },
  },

  computed: {
    isLdap() {
      return !!(this.item && this.item.type === DirectoryTypeConsts.ldapServer);
    },

    showLdapBindDn() {
      return !!(this.isLdap && this.parent && this.parent.ldap_binding_user);
    },

    showSambaServiceAccount() {
      return !!(this.isLdap && this.parent && this.parent.samba_service_user);
    },
  },

  beforeCreate() {
    if (this.$options.propsData.parentType) {
      this.$options.methods.asidePanelChildComponentHandleBeforeCreate(this.$options, true);
    }
  },
};
</script>
<style module>
.item + .item {
  margin-top: 3px;
}

.icon,
.text {
  vertical-align: middle;
}

.icon {
  font-size: 16px;
  margin-right: 8px;
}

.text {
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
}
</style>
